import { type InputHTMLAttributes, forwardRef } from "react";
import Icon from "./Icon/Icon";

import { cn } from "@/lib/cn";

type Props = InputHTMLAttributes<HTMLInputElement>;

const SearchInput = forwardRef<HTMLInputElement, Props>(
  ({ className, type = "text", ...props }, ref) => (
    <div
      className={cn(
        "flex h-9 w-full items-center rounded-md border border-neutral-muted-border bg-neutral-fill px-3 shadow-sm",
        "has-[input:focus]:ring-1 has-[input:focus]:ring-ring",
        className,
      )}
    >
      <Icon iconName="SearchIcon" className="mr-1.5 text-muted-foreground" />
      <input
        ref={ref}
        type={type}
        className="w-full text-xs outline-none placeholder:text-muted-foreground"
        {...props}
      />
    </div>
  ),
);
SearchInput.displayName = "SearchInput";

export default SearchInput;
